import React, { useState } from 'react';
import { Descriptions, Modal } from 'antd';
import styled from 'styled-components';

import { DARK_MODAL_CLASS } from 'components/theme/DarkPageScope/constants';
import API from 'utils/request';

import { getCardType } from '../filters/filterOptions';
import { ICustomerCard } from './BDOCustomerCard';

interface ICardModalProps {
  open: boolean;
  cardProps: ICustomerCard['cardProps'];
  closeModal: () => void;
  onCancel: () => void;
  refetchCustomer: () => void;
}
const BlockCardModal = ({
  open,
  cardProps,
  closeModal,
  onCancel,
  refetchCustomer
}: ICardModalProps) => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  return (
    <StyledModal
      wrapClassName={DARK_MODAL_CLASS}
      open={open}
      title="Block card?"
      bodyStyle={{ padding: '30px 38px' }}
      confirmLoading={confirmLoading}
      okButtonProps={{
        style: { backgroundColor: 'red', border: 'transparent', fontWeight: '600' }
      }}
      okText="Block card"
      onOk={async () => {
        setConfirmLoading(true);
        try {
          await API.patch(
            `/v4/dash/custom/bdo/card_status/${cardProps.brc}`,
            {
              card: {
                'Card Status': 'B',
                'Activity Description': 'Blocked',
                Remarks: 'Blocked'
              }
            },
            { headers: { 'Content-Type': 'application/json' } }
          );
          setConfirmLoading(false);
          closeModal();
          Modal.success({
            title: 'Card successfully blocked',
            content: (
              <div>
                <p>BRC {cardProps.brc} has been successfully blocked.</p>
              </div>
            ),
            onOk() {
              refetchCustomer();
            }
          });
        } catch (e) {
          const errorMsg = e?.response?.data?.message;
          setConfirmLoading(false);
          closeModal();
          Modal.error({
            title: 'Card blocking failed',
            content: <div>{errorMsg && <p>{errorMsg}</p>}</div>
          });
        }
      }}
      onCancel={onCancel}
    >
      <Descriptions column={{ sm: 1 }} colon={false} layout="horizontal" title="">
        <Descriptions.Item key="brc" label="BRC">
          <strong>{cardProps?.brc}</strong>
        </Descriptions.Item>
        <Descriptions.Item key="tier" label="Tier">
          <strong>{getCardType(cardProps?.tier)?.label}</strong>
        </Descriptions.Item>
        <Descriptions.Item key="seq" label="Seq">
          <strong>{cardProps?.sequence}</strong>
        </Descriptions.Item>
      </Descriptions>
      Are you sure you want to block this card?
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  .ant-modal-header {
    background-color: red;
    color: white;
  }

  .ant-modal-title {
    color: white;
    font-weight: 600;
  }

  .ant-modal-close-x {
    color: white;
  }
`;

export default BlockCardModal;
